
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSwitch as ObcSwitchElement} from '@oicl/openbridge-webcomponents/dist/automation/switch/switch.js';
 
 
 

 
 export const ObcSwitch = createComponent({
   react: React,
   tagName: 'obc-switch',
   elementClass: ObcSwitchElement,
   events: {
     
   }
  });
 
 